import { useContext, useEffect, useState } from "react";
import { AppContext } from "../App";
import { PiBuildingOfficeBold, PiStudent } from "react-icons/pi";
import {
  CDN_URL,
  formatMoney,
  formatMoneyShorten,
  getCurrentYear,
} from "../Helpers";
import { FaPlay } from "react-icons/fa";
import { SiGoogleclassroom } from "react-icons/si";
import { IoIosPeople } from "react-icons/io";
import { getInlineLoader } from "../Helpers";
import { MdCheck, MdLocationPin, MdSearch } from "react-icons/md";

export default function OneService({ data }) {
  const appContext = useContext(AppContext);

  /* Place states here */
  const [ready, setReady] = useState(false);

  function view() {
    appContext.navTo({
      item: "view",
      subItem: "gallery",
      extraItem: data.uuid,
    });
  }

  return (
    <div
      className="card"
      style={{
        height: "400px",
        cursor: "pointer",
        backgroundImage: `url(${CDN_URL + data.cover_photo})`,
        backgroundPosition: "center",
        backgroundSize: "cover",
        backgroundRepeat: "no-repeat",
        position: "relative",
        overflow: "hidden",
        marginBottom: "20px",
      }}
      onClick={() => {
        view();
      }}
    >
      {data.video ? (
        <div
          style={{
            position: "absolute",
            inset: 0,
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            zIndex: 2,
            pointerEvents: "none",
          }}
        >
          <div
            style={{
              width: "56px",
              height: "56px",
              borderRadius: "50%",
              background: "rgba(255,255,255,0.9)",
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              boxShadow: "0 4px 12px rgba(0,0,0,0.25)",
            }}
          >
            <FaPlay color="#111" size={22} />
          </div>
        </div>
      ) : null}

      <div
        style={{
          width: "100%",
          height: "100%",
          background:
            "linear-gradient(to top, rgba(0,0,0,0.9) 0%, rgba(0,0,0,0.6) 30%, rgba(0,0,0,0) 100%)",
          position: "relative",
        }}
      ></div>

      <div
        style={{
          width: "100%",
          height: "auto",
          position: "absolute",
          padding: "20px",
          bottom: 0,
          left: 0,
        }}
      >
        <h6
          style={{
            fontSize: "14px",
            flex: 1,
            minWidth: 0,
            textTransform: "uppercase",
            marginRight: "8px",
            display: "-webkit-box",
            WebkitLineClamp: 3, // max 3 lines
            WebkitBoxOrient: "vertical",
            overflow: "hidden",
            textOverflow: "ellipsis",
          }}
          className="font-bold align-self-center text-light mNoMargin"
        >
          {data.title}
        </h6>
      </div>
    </div>
  );
}
